<template>
  <div class="element">
    <BasicText
      size="body-xl"
      weight="bold"
      class="element__title"
      color="white"
    >
      {{ title }}
    </BasicText>

    <div class="element__bloc">
      <slot name="header" />
      <slot name="items">
        <div
          v-for="item in displayItems"
          :key="item.label"
          class="element__bloc__items"
        >
          <BasicText
            size="body-m"
            color="secondary-900"
          >
            <BasicText
              size="body-m"
              weight="bold"
            >
              {{ item.label }}:
            </BasicText>
            {{ item.value ?? '' }}
          </BasicText>
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  const props = defineProps<{
    title: string
    items: object
  }>()

  const displayItems = computed(() => Object.entries(props.items).map(([label, value]) => ({ label, value })))
</script>

<style scoped lang="less">
  .element {
    display: flex;
    flex-direction: column;
    gap: @spacing-10;

    &__title {
      background-color: @secondary-800;
      padding: @spacing-15;
      border-radius: @border-radius-l;
      text-align: center;
    }

    &__bloc {
      flex: 1;
      background-color: #f6fbff;
      padding: 8px 24px;
      border-radius: @border-radius-l;

      &__items {
        background-color: #f6fbff;
        display: flex;
        flex-direction: column;
        margin: @spacing-5;
      }
    }
  }
</style>
